import { Component, OnInit, OnDestroy, Inject,ViewEncapsulation } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA,  MatDialog} from '@angular/material';
import { StaffService } from '../staff.service';
import { StaffForCreationResponse, checkPhoneNumberOtp, checkEmailOtp } from '../staff';
import { Http } from '@angular/http';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage } from '../../../app-general';
import {appsettings} from '../../../app-settings';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-verify-staff',
  templateUrl: './verify-staff.component.html',
  providers: [ StaffService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./verify-staff.component.scss']
})
export class VerifyStaffComponent implements OnInit, OnDestroy {

  watcher: Subscription;
  columns: number = 3;
  public staffVerificationForm : FormGroup;
  countrycode;
  countrycodetext;
  staffphonenumber;
  staffotpvalue = 0;
  verifystaffcode = true;
  private staffURL = appsettings.URLinfo+'request_OTP_Verification';
  staffverifyotpresult;
  checkStaffVerifyflag;
  verifyStaffId;
  verifyOTPNumber;
  boolstaffphoneotpverify : boolean = true;
  boolstaffemailotpverify : boolean = true;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,mediaObserver: MediaObserver,private staffService: StaffService,public thisDialogRef: MatDialogRef<VerifyStaffComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,@Inject(RollbarService) private rollbar: Rollbar, public dialog: MatDialog, 
 private http:Http) {
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {         
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;
        }                 
      }
    });       
    
    if(data.StaffFlag == 0)
    {

      this.staffphonenumber = data.StaffVerify;      
      if(this.staffphonenumber.length == 10)
      {
          this.staffphonenumber = data.StaffVerify;  
          this.countrycode = localStorage.getItem("country_code");
      }      
    }  
    else
    {
      this.staffphonenumber = data.StaffVerify;    
    }
    
    this.checkStaffVerifyflag = data.StaffFlag;
    this.verifyStaffId = data.StaffId;
    this.verifyOTPNumber = data.OTPNumber;
  }

  ngOnInit() {
    this.staffVerificationForm = new FormGroup({
      contrycode: new FormControl(''),
      staffphonenumber: new FormControl(''),
      otpnumber : new FormControl('',[Validators.required,Validators.maxLength(4)]),            
    });

    this.staffVerificationForm.get('contrycode').disable();
    this.staffVerificationForm.get('staffphonenumber').disable();
  }

  public onCloseCancel = () => {
    if(!SessionCheck(this.router))
    {
        return;
    }
    this.thisDialogRef.close('Cancel');
  }

  public VerifyStaffNumber = (staffVerificationForm) => {
    try
    {
      if(!SessionCheck(this.router))
      {
          return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.staffVerificationForm.valid && (this.boolstaffphoneotpverify || this.boolstaffemailotpverify)) {  
          if(this.boolstaffphoneotpverify)
            this.boolstaffphoneotpverify = false;
          if(this.boolstaffemailotpverify)
            this.boolstaffemailotpverify = false;
          this.verifyPhoneNumberEmailOTP(staffVerificationForm);
      }
    }  
    catch (err) {
      throw new Error('verify-staff.component.ts' + ' - VerifyStaffNumber() - ' + err.message);
    }
  }

verifyPhoneNumberEmailOTP(staffVerificationForm)
{
  try
  {  
    if(this.checkStaffVerifyflag == 0)
    {
        let staffverifyotpnumber : checkPhoneNumberOtp = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"), 
          phoneNumber:this.staffphonenumber.toString(),
          countryCode:this.countrycode.toString(),
          otpNumber:staffVerificationForm.otpnumber.toString()
        }
        this.staffService.verifyPhoneNumberOTP(staffverifyotpnumber).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : StaffForCreationResponse[])=>{                 
          if(apiresponse.toString() == "true")
          { 
            this.staffotpvalue = 1;
            this.boolstaffphoneotpverify = false;
            generateAlertMessage(this.dialog, "Your mobile number Enrolled successfully.");         
            this.thisDialogRef.close(this.staffotpvalue); 
          }
          else if(apiresponse.toString() == "false")
          {
            this.boolstaffphoneotpverify = true;
            this.staffotpvalue = 0;
            generateAlertMessage(this.dialog, "Verification code is incorrect");
          }
      })  
    }     
    else if(this.checkStaffVerifyflag == 1)
    {
      if(this.verifyOTPNumber > 0)
      {
          if(staffVerificationForm.otpnumber == this.verifyOTPNumber)
          {
            this.staffotpvalue = 1;
            this.boolstaffemailotpverify = false;
            generateAlertMessage(this.dialog, "Your email Id Enrolled successfully.");                     
            this.thisDialogRef.close(this.staffotpvalue); 
          }
          else if(staffVerificationForm.otpnumber != this.verifyOTPNumber)
          {
            this.boolstaffemailotpverify = true;
            this.staffotpvalue = 0;
            generateAlertMessage(this.dialog, "Verification code is incorrect");
          }
      }
      else
      {
          let staffverifyotpnumber : checkEmailOtp = 
          {
            siteId: this.SiteId, 
            authKey: localStorage.getItem("Authkey"),
            staffId:this.verifyStaffId.toString(),
            otpNumber:staffVerificationForm.otpnumber.toString()
          }        
          this.staffService.verifyEmailOTP(staffverifyotpnumber).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : StaffForCreationResponse[])=>{              
            if(apiresponse.toString() == "true")
            { 
              this.staffotpvalue = 1;
              this.boolstaffemailotpverify = false;
              generateAlertMessage(this.dialog, "Your email Id Enrolled successfully.");         
              this.thisDialogRef.close(this.staffotpvalue); 
            }
            else if(apiresponse.toString() == "false")
            {
              this.boolstaffemailotpverify = true;
              this.staffotpvalue = 0;
              generateAlertMessage(this.dialog, "Verification code is incorrect");
            }
        })  
      }
    }            
  }  
  catch (err) {
    throw new Error('verify-staff.component.ts' + ' - verifyPhoneNumberEmailOTP() - ' + err.message);
  }
}


ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}

}
